import styles from "../../styles/Components/new-dashboard/DashboardBadge.module.css";

// type: "dangerous", "primary", "success", "warning", "secondary"
function DashboardBadge({
  type,
  children,
  usage = "preview",
  style = {},
  onClick,
  className = "",
}) {
  return (
    <div
      className={`${styles.badge} ${styles?.[type]} ${usage === "preview" ? styles.previewBadge : styles.normalBadge} ${className}`}
      style={{ ...style }}
      onClick={() => (onClick ? onClick() : "")}
    >
      {children}
    </div>
  );
}

export default DashboardBadge;
